// extracted by mini-css-extract-plugin
module.exports = {"home":"style_home__8uDly","home__top":"style_home__top__iVxdX"};